<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import validator from 'validator';
import Background from '@/components/Background';
import Navbar from '@/components/Navbar';
import BackButton from '@/components/BackButton';
import TollfreeNumberInput from '@/components/TollfreeNumberInput';
import NumberSearchButton from '@/components/NumberSearchButton';
import PortingNumberInput from '@/components/PortingNumberInput';
import LocalNumberInput from '@/components/LocalNumberInput';
import { isMobile } from '@/utils';

export default {
  name: 'SearchNumber',
  components: {
    Background,
    Navbar,
    BackButton,
    TollfreeNumberInput,
    NumberSearchButton,
    LocalNumberInput,
    PortingNumberInput
  },
  data() {
    return {
      inputValue: '',
      type: this.$route.query.type,
      disabled: true,
      buttonIcon: '',
      error: ''
    };
  },
  computed: {
    features() {
      return this.type === 'tollfree'
        ? [
            'Use 3 to 7 letters or numbers',
            'Shorter terms are more likely to return a match',
            'Example Numbers: (800) FLOWERS, (877) 526 JOHN'
          ]
        : this.type === 'local'
        ? ['Enter your preferred 3-digit area code to generate a list of available phone numbers']
        : [``];
    },
    title() {
      return this.type === 'tollfree'
        ? 'Get the perfect toll free vanity number'
        : this.type === 'local'
        ? 'Which local area code are you looking for?'
        : 'Get Voyyp on your current number';
    },
    tollfreeText() {
      return isMobile() ? 'Get a randomly number' : 'Get a randomly generated toll free number';
    }
  },
  methods: {
    /**
     * Search the numbers
     * @returns {boolean|void}
     */
    async onSearch() {
      this.buttonIcon = 'loading';
      gtag_report_conversion();

  
      if (this.disabled) {
          this.buttonIcon = '';
      this.disabled = false;

          this.error = 'Please enter a valid phone number';
      

        return false;
      }
                 
   

                                                     
      if (this.type === 'porting') {
        this.$router.push('/numbers/porting');
        return;
      }

      this.disabled = true;
      try {
        // the query is located in /src/api/index.ts
        await this.$store.dispatch('onboarding/setSuggestedNumbers', {
          areaCode: this.type === 'tollfree' ? '' : this.inputValue,
          key: this.inputValue,
          type: this.type
        });
                                                                        


        const { numberSearchError } = this.$store.state.onboarding;
        if (numberSearchError) {
                  this.buttonIcon = '';
    






          return (this.error = numberSearchError);
        }

        this.disabled = false;
        this.buttonIcon = '';
        return this.$router.push(`/numbers/select?type=${this.type}&key=${this.inputValue}`);
      } catch (error) {
                 this.buttonIcon = '';
    
       
        return (this.error = numberSearchError);
      }
    },

    onChange() {
      if (this.type === 'tollfree') {
        this.disabled = this.inputValue.length < 3;
      } else if (this.type === 'local') {
        this.disabled = this.inputValue.length !== 3;
      } else if (this.type === 'porting') {
        this.disabled = !validator.isMobilePhone(this.inputValue, 'en-US');
      }
      this.error = '';
    },

    async onRandomGenerate() {
      await this.$store.dispatch('onboarding/setSuggestedNumbers', {
        type: 'tollfree',
        areaCode: '',
        key: 'a' + (Math.floor(Math.random() * 100) % 26)
      });
      const { numberSearchError } = this.$store.state.onboarding;
      if (numberSearchError) {
        return (this.error = numberSearchError);
      }

      return this.$router.push('/numbers/select?type=tollfree_random');
    }
  }
};
</script>
